import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartnersComponent} from './partners/partners.component';
import {RouterModule, Routes} from '@angular/router';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {JoyrideModule} from 'ngx-joyride';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {PipeModule} from '~/app/shared/pipe/pipe.module';
import { DetailComponent } from './detail/detail.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import {FormsModule} from '@angular/forms';

export const PartnersRoutes: Routes = [
    {path: '', component: PartnersComponent},
];

@NgModule({
    declarations: [
        PartnersComponent,
        DetailComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(PartnersRoutes),
        MatProgressSpinnerModule,
        MatTableModule,
        JoyrideModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        PipeModule,
        MatCheckboxModule,
        MatDialogModule,
        Nl2BrPipeModule,
        FormsModule,
    ]
})
export class PartnersModule {
}
